import { SymbolRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasSymbolPicker } from "../constants";

import { DefaultCanvasSymbolPicker } from "./symbol-picker";

let loadSymbolPick = !1;

export function bindSymbolCanvasPickerContribution(container) {
    loadSymbolPick || (loadSymbolPick = !0, container.bind(CanvasSymbolPicker).toDynamicValue((() => new DefaultCanvasSymbolPicker(resolveContainerBinding(container, SymbolRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasSymbolPicker));
}
//# sourceMappingURL=symbol-module.js.map
